/**
 * Shopify Forms sets inline width:Npx on #form-container-ref (often ~450px).
 * Match the available width of our theme wrapper — never wider (prevents overflow).
 * Uses ResizeObserver + short poll only (no style MutationObservers → no freeze).
 */
(function () {
  var POLL_MS = 400;
  var POLL_FOR_MS = 8000;

  function availableWidth(host) {
    var wrapper = host.closest('.return-form__shopify-form');
    if (!wrapper) return 0;
    // clientWidth = content box inside the padded page-width column
    return Math.floor(wrapper.clientWidth);
  }

  function ensureShadowSheet(root) {
    if (root.__sweydWidthSheet) return;
    root.__sweydWidthSheet = true;
    var css =
      '#form-container-ref,' +
      '[data-sizing="form-wrapper"],' +
      '[class*="_inline_"] {' +
      'box-sizing:border-box!important;' +
      'max-width:100%!important;' +
      'margin-left:0!important;' +
      'margin-right:0!important;' +
      '}';
    try {
      var sheet = new CSSStyleSheet();
      sheet.replaceSync(css);
      root.adoptedStyleSheets = (root.adoptedStyleSheets || []).concat(sheet);
    } catch (e) {
      var style = document.createElement('style');
      style.textContent = css;
      root.appendChild(style);
    }
  }

  function syncHost(host) {
    var root = host.shadowRoot;
    if (!root) return false;

    var ref = root.querySelector('#form-container-ref');
    if (!ref) return false;

    ensureShadowSheet(root);

    var width = availableWidth(host);
    if (!width) return true;

    // Never exceed the wrapper; keep 1px under to avoid subpixel scrollbars
    width = Math.max(0, width - 1);

    var current = parseInt(ref.style.width, 10);
    if (current === width) return true;

    host.style.setProperty('display', 'block');
    host.style.setProperty('width', '100%');
    host.style.setProperty('max-width', '100%');
    host.style.setProperty('box-sizing', 'border-box');
    host.style.setProperty('--inline-container-max-width', width + 'px');

    ref.style.setProperty('width', width + 'px', 'important');
    ref.style.setProperty('max-width', width + 'px', 'important');
    ref.style.setProperty('box-sizing', 'border-box', 'important');

    return true;
  }

  function syncAll() {
    document
      .querySelectorAll('.return-form__shopify-form shopify-forms-embed, .return-form__shopify-form form-embed')
      .forEach(syncHost);
  }

  function watchHost(host) {
    if (!host || host.__sweydWidthWatched) return;
    host.__sweydWidthWatched = true;

    var wrapper = host.closest('.return-form__shopify-form');
    if (wrapper && typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(function () {
        syncHost(host);
      }).observe(wrapper);
    }

    var started = Date.now();
    var poll = setInterval(function () {
      syncHost(host);
      if (Date.now() - started > POLL_FOR_MS) clearInterval(poll);
    }, POLL_MS);
  }

  function scan() {
    document
      .querySelectorAll('.return-form__shopify-form shopify-forms-embed, .return-form__shopify-form form-embed')
      .forEach(watchHost);
    syncAll();
  }

  var resizeTimer = null;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(syncAll, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  setTimeout(scan, 300);
  setTimeout(scan, 1200);

  window.addEventListener('resize', onResize);
  window.addEventListener('orientationchange', onResize);
})();
